const Filter = () => {
	return <></>;
};

export default Filter;
